import type { ProjectWriteStatusCounts } from './conflict-review-store';

export type ProjectWriteHeaderStatus = 'synced' | 'pending';

export function getProjectWriteHeaderStatus(input: {
    counts: ProjectWriteStatusCounts;
    lastSync: string | null | undefined;
}): ProjectWriteHeaderStatus {
    if (input.counts.pending > 0) {
        return 'pending';
    }

    return input.lastSync ? 'synced' : 'pending';
}
